import { StateCreator } from 'zustand';
import { IAppStore } from '../../IAppStore';
import ConfiguratonSlice from './ConfigurationSlice';

const createConfigurationSlice: StateCreator<IAppStore, [], [], ConfiguratonSlice> = (
  set,
) => ({
  applyConfiguration: (configuration) => {
    set({
      selectedBasemapId: configuration.basemap.selectedBasemapId,
      isBasemapVisible: configuration.basemap.isBasemapVisible,
      basemapOpacity: configuration.basemap.basemapOpacity,
      selectedTopicLayers: configuration.topicLayers,
      topicLayerSettings: configuration.topicLayerSettings,
      topicSubLayerSetting: configuration.topicSubLayerSetting,
    });
  },
});

export default createConfigurationSlice;
